// extracted by mini-css-extract-plugin
export default {"error_page":"styles_error_page__ql5k6","error__wrapper":"styles_error__wrapper__4cXi6","error__text":"styles_error__text__CYRVK","reload_button":"styles_reload_button__F+D5E"};